import React from 'react'
import appleLogo from './apple-logo.png'

const AppleSVG = () => {
  return (
    <img
      src={appleLogo}
      alt="Apple"
      width="20"
      height="20"
      style={{ display: 'block' }}
    />
  )
}

export default AppleSVG
